module.exports = __webpack_public_path__ + "img/people1.11d2a30e.png";